import { useFormik } from "formik";
import cookie from "js-cookie";
import { useRouter } from "next/router";
import { Button, Dropdown } from "react-bootstrap";
import { countries } from "../../constants";
import ReactCountryFlag from "react-country-flag";
import * as Yup from "yup";
import { requestCallback } from "../../../api.services.js/others";

export default function RequestCallbackForm() {
  const router = useRouter();

  const isExport =
    router.asPath.includes("/tile-exports") ||
    router.asPath.includes("/download-export-catalogue");

  // Validation schema
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Name should only contain letters and spaces"),
    number: Yup.string()
      .length(10, "Mobile number must be 10 digits")
      .matches(/^\d+$/, "Mobile number must be numeric")
      .required("Mobile number is required"),
    email: isExport
      ? Yup.string().email("Invalid Email format").required("Email is required")
      : Yup.string().nullable(),
    pincode: !isExport
      ? Yup.string().nullable().length(6, "Invalid Pincode")
      : Yup.string().nullable(),
    countryCode: isExport
      ? Yup.string().required("Please select a country code")
      : Yup.string(),
    cc: isExport ? Yup.string().required("Missing country flag") : Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      number: "",
      email: "",
      pincode: cookie.get("pincode") || "",
      countryCode: "",
      cc: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, setErrors, resetForm }) => {
      try {
        const response = await requestCallback({
          name: values.name,
          phone: values.number,
          pincode: values.pincode,
          email: values.email,
        });

        if (response?.message) {
          localStorage.setItem("leadfilled", true);
          swal(response?.message);
        } else {
          response?.data?.request_callback?.msg
            ? swal("Success", "Your details have been submitted!", "success")
            : swal(
                "Error",
                "Something went wrong. Please try again later.",
                "error"
              );
        }
      } catch (error) {
        console.error("Submission error", error);
        setErrors({ general: "Something went wrong. Please try again." });
      } finally {
        resetForm();
        setSubmitting(false);
      }
    },
  });

  const handleCountrySelect = (code) => {
    const country = countries.find((c) => c.code === code);
    if (country) {
      formik.setFieldValue("countryCode", country.code);
      formik.setFieldValue("cc", country.cc);
    }
  };

  return (
    <form className="flex-class" onSubmit={formik.handleSubmit}>
      <div className="form-group">
        <input
          type="text"
          name="name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Name"
          className="input-bx"
        />
        {formik.touched.name && formik.errors.name && (
          <div className="text-danger">{formik.errors.name}</div>
        )}
      </div>

      <div className="form-group">
        {isExport && (
          <>
            <Dropdown onSelect={handleCountrySelect}>
              <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                {formik.values.countryCode ? (
                  <div>
                    <ReactCountryFlag countryCode={formik.values.cc} svg />
                    {` (${formik.values.countryCode})`}
                  </div>
                ) : (
                  "Country"
                )}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                {countries.map((country, index) => (
                  <Dropdown.Item key={index} eventKey={country.code}>
                    <div>
                      <ReactCountryFlag countryCode={country.cc} svg />
                      {`${country.name} (${country.code})`}
                    </div>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {formik.touched.countryCode && formik.errors.countryCode && (
              <div className="text-danger mt-1">
                {formik.errors.countryCode}
              </div>
            )}
          </>
        )}
        <input
          type="number"
          name="number"
          value={formik.values.number}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Mobile Number"
          className="input-bx"
        />
        {formik.touched.number && formik.errors.number && (
          <div className="text-danger">{formik.errors.number}</div>
        )}
      </div>

      {isExport ? (
        <div className="form-group">
          <input
            type="email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Email"
            className="input-bx"
          />
          {formik.touched.email && formik.errors.email && (
            <div className="text-danger">{formik.errors.email}</div>
          )}
        </div>
      ) : (
        <div className="form-group">
          <input
            type="number"
            name="pincode"
            value={formik.values.pincode}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Pincode (Optional)"
            className="input-bx"
          />
          {formik.touched.pincode && formik.errors.pincode && (
            <div className="text-danger">{formik.errors.pincode}</div>
          )}
        </div>
      )}

      <div className="form-group button">
        <Button
          className="ft-submit-btn"
          type="submit"
          disabled={formik.isSubmitting}
        >
          {formik.isSubmitting ? "Submitting" : "Submit"}
        </Button>
      </div>

      {formik.errors.general && (
        <p className="error text-danger">{formik.errors.general}</p>
      )}
    </form>
  );
}
